import { IModel } from '@/@types/models/model';
import coreFields from './helpers/coreFields';
import buttonFields from './helpers/buttonFields';

const GFIModelFields: IModel = {
  title: 'Model Fields',
  apiPath: 'system/models/{id}/fields',
  forms: {
    insert: {
      fields: ['source', 'ftype', 'ttoken', 'model_section_id', 'sortorder', 'image_max_width', 'image_max_height'],
    },
    update: {
      fields: ['source', 'ftype', 'ttoken', 'model_section_id', 'sortorder', 'image_max_width', 'image_max_height'],
    },
  },
  listViews: {
    default: {
      fields: [
        'id',
        'model_id',
        'source',
        'ftype',
        'ttoken',
        'model_section_id',
        'sortorder',
        'created_on',
        'created_by',
        'modified_on',
        'modified_by',
        'edit',
      ],
    },
  },
  fields: [
    coreFields.id,
    coreFields.created_on,
    coreFields.created_by,
    coreFields.modified_on,
    coreFields.modified_by,
    {
      title: 'model_id',
      source: 'model_id',
      ttoken: 'admin:common.model_id',
      type: 'numeric',
      validation: {
        required: true,
      },
    },
    {
      title: 'source',
      source: 'source',
      ttoken: 'admin:common.source',
      type: 'text',
      validation: {
        required: true,
        maxLength: 50,
      },
    },
    {
      title: 'ftype',
      source: 'ftype',
      ttoken: 'admin:fields.ftype',
      type: 'picker',
      items: {
        labels: ['text', 'numeric', 'wholenum', 'boolean', 'date', 'datetime', 'ttoken', 'images', 'link', 'array', 'images_url', 'image_api'],
        values: ['text', 'numeric', 'wholenum', 'boolean', 'date', 'datetime', 'ttoken', 'images', 'link', 'array', 'images_url', 'image_api'],
      },
      validation: {
        required: true,
        maxLength: 20,
      },
    },
    {
      title: 'ttoken',
      source: 'ttoken',
      ttoken: 'admin:fields.ttoken',
      type: 'text',
      validation: {
        required: true,
        maxLength: 50,
      },
    },
    {
      title: 'model_section_id',
      source: 'model_section_id',
      ttoken: 'admin:model_fields.model_section',
      type: 'picker',
      subModel: {
        apiPath: 'system/models/{model_id}/sections?view=picker',
        format: '{label}',
        idattr: 'id',
      },
      translate: true,
    },
    {
      title: 'sortorder',
      source: 'sortorder',
      ttoken: 'core:common.sortorder',
      type: 'numeric',
    },
    {
      title: 'image_max_width',
      source: 'image_max_width',
      ttoken: 'admin:model_fields.image_max_width',
      type: 'wholenum',
    },
    {
      title: 'image_max_height',
      source: 'image_max_height',
      ttoken: 'admin:model_fields.image_max_height',
      type: 'wholenum',
    },
    buttonFields.edit,
  ],
};

export default GFIModelFields;
